export default __webpack_public_path__ + "static/media/settings-icon.3b355c7b.svg";